export { default, LinkOnlyInternalAnimations } from "./Link.js";
